<template>
	<div class="" @keyup.enter="handleSubmit" id='login'>
		<div id='lgbg'></div>
		<div id='lgform' v-loading='loading'>
			<img :src='lglogin' />
			<div id='lgtt'>{{$t('login_title')}}</div>
			<div id='lgformct'>
				<el-form ref="form" :model="lgfm" :rules="rules" label-width="0px">
					<el-form-item style="margin-top:-5px;">
						<el-input placeholder="" readonly v-model="langName" class="input-with-select"
							style="margin-top:20px;">

							<el-dropdown trigger="click" slot="append" placement='bottom-end' @command='langchange'>
								<span class="el-dropdown-link">
									<img :src='langUrl' style="width:24px;height:16px;margin-top:5px;" />
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item v-for='item in langs' :command='item.value'><img :src='item.url'
											style='width:24px;' /> &nbsp;{{item.label}}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</el-input>
					</el-form-item>

					<el-form-item prop="id">
						<el-input size='small' v-model="lgfm.id">
							<i style="margin-left:5px;" slot="prefix" class="fa fa-user"></i>
						</el-input>
					</el-form-item>
					<el-form-item style="margin-top:-5px;" prop="psw">
						<el-input size='small' v-model="lgfm.psw" show-password>
							<i style="margin-left:5px;" slot="prefix" class="fa fa-lock"></i>
						</el-input>
					</el-form-item>
					<el-form-item style="margin-top:-5px;" prop="code">
						<el-row>
							<el-col :span="12">
								<img @click="getCode()" :src="coderes.code" style="display:block;margin:0;" />
							</el-col>
							<el-col :span="12">
								<el-input size='small' v-model="lgfm.code" :placeholder="$t('login_ckcode')"></el-input>
							</el-col>
						</el-row>
					</el-form-item>
				</el-form>
			</div>

			<el-row id='lgfun'>
				<el-col :span='12'>
					<!-- <el-checkbox v-model="autoLoginCheck" style="float:left;margin-top:3px;">
            <label style="font-size:13px;">自动登录</label>
          </el-checkbox> -->
				</el-col>
				<el-col :span='12'>
					<!-- <el-button style="float:right;" type='text' size='mini'>忘记密码？</el-button> -->
				</el-col>
			</el-row>

			<el-button @click="handleSubmit" id='lgbtn' type='primary' size='small'>{{$t('login_button')}}</el-button>
		</div>
		<div id='lgcpcp'>
			{{$t('app_comment')}}
		</div>
		<el-dialog @close="closeDia" class='gstdia' :placeholder="$t('reset_password')" :visible.sync="showdia">
			<el-form mmodel="tform" rrules="rules" ref="ruleForm">
				<el-form-item :label="$t('new_password')" :label-width="$formlbWidth" prop='accessid'>
					<el-input v-model="npsw" type="password" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('sure_password')"  :label-width="$formlbWidth" prop='accesskey'>
					<el-input v-model="npsw1" type="password" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth" style="text-align:left;">
					<el-button @click="closeDia">{{$t('app_cancel')}}</el-button>
					<el-button type="primary" @click="resetRqs">{{$t('app_sure')}}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

	</div>
</template>

<script>
	var md5 = require('md5');
	import lglogin from '../assets/lglogin.svg'
	import JSEncrypt from 'jsencrypt'
	import req from '../api/req.js'

	export default {
		data() {
			return {
				value: "",
				langItem: {
					'zh_cn': {
						label: '中文',
						url: require('../assets/chinese.png')
					},
					'en': {
						label: 'English',
						url: require('../assets/english.png')
					},
					'vi': {
						label: 'Việt nam',
						url: require('../assets/vi.png')
					},
					// 'ko': {
					// 	label: '한국어',
					// 	url: require('../assets/korea.png')
					// },
					// 'ru': {
					// 	label: 'русский ',
					// 	url: require('../assets/russia.png')
					// },
					// 'japan': {
					// 	label: '日本語',
					// 	url: require('../assets/jpan.png')
					// },
				},
				langs: [{
						value: 'zh_cn',
						label: '中文',
						url: require('../assets/chinese.png')
					}, {
						value: 'en',
						label: 'English',
						url: require('../assets/english.png')
					},
					{
						value: 'vi',
						label: 'Việt nam',
						url: require('../assets/vi.png')
					},
					// {
					// 	value: 'ru',
					// 	label: 'русский ',
					// 	url: require('../assets/russia.png')
					// },
					// {
					// 	value: 'ko',
					// 	label: '한국어',
					// 	url: require('../assets/korea.png')
					// },
					// {
					// 	value: 'japan',
					// 	label: '日本語',
					// 	url: require('../assets/jpan.png')
					// }
				],



				tmptoken: "",
				lglogin: lglogin,
				loading: false,
				autoLoginCheck: false,
				showdia: false,
				show_reset: false,
				coderes: '',
				npsw1: '',
				npsw: '',
				pbkey: "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC/rNFBXBVIgDKvpc6jGUSq+uh03gvrP1MQyMPcuWcQY7OGeiLspZnL2mWyv3wmvFm9bpP2C0g26aO5Ln8y6jkIfXqkRTi/pTNJkUAZPKm0jno11+YuxxwsHOpQ9VY4krLueLjADjqsjFV+IKo4ZLNJtgPTC/XtPoQVqWB3+CyLWwIDAQAB",
				lgfm: {
					id: '',
					psw: '',
					code: ''
				},
				rules: {
					id: [{
						required: true,
						message: this.$t('login_account'),
						trigger: 'change'
					}],
					psw: [{
						required: true,
						message: this.$t('login_password'),
						trigger: 'change'
					}],
				}
			}
		},
		mounted() {
			this.getCode()
			if (this.$getTmp('loginTag')) {
				this.$router.push({
					path: '/'
				})
			}
		},
		computed: {
			langName() {
				return this.langItem[this.value].label
				// return "English"

			},
			langUrl() {
				return this.langItem[this.value].url
				// return require('../assets/english.png')
			}
		},
		created() {
			if (!localStorage.getItem("lang_jp")) {
				this.value = "zh_cn";
			} else {
				this.value = localStorage.getItem("lang_jp")
			}
		},
		methods: {
			langchange(vl) {
				// console.log(vl)
				this.langEvent(vl)
			},
			langEvent(val) {
				localStorage.setItem("lang_jp", val);
				req.common.changeLang(val);
				localStorage.setlang = '1'
				window.location.reload(true);
			},
			closeDia() {
				this.showdia = false
				this.npsw1 = ''
				this.npsw = ''
			},
			resetRqs() {
				var iserr = true
				var reg = /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_])).{8,}$/
				if (!this.npsw || !this.npsw1) { 
					this.$message.error(this.$t('password_error'))
				} else if (this.npsw1 != this.npsw) {
					this.$message.error(this.$t('password_error_2'))
				} else if (!reg.test(this.npsw)) {
					this.$message.error(this.$t('password_error_3'))
				} else {
					iserr = false
				}
				if (iserr) {
					return
				}
				this.loading = true
				this.$resetPsw(this.lgfm.id, md5(this.npsw), this.tmptoken, res => {
					this.loading = false
					if (res.status == 200) {
						this.closeDia()
						this.$message.success(res.message)
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = false
				})
			},
			getCode() {
				this.$getCode(res => {
					this.coderes = res.data
					this.coderes.code = this.atou(this.coderes.code)
				}, '')
			},
			atou(str) {
				return decodeURIComponent(escape(window.atob(str)))
			},
			handleSubmit() {
				var _this = this
				this.$refs['form'].validate(function(result) {
					if (result) {
						_this.getCode()
						// 验证通过
						_this.loading = true
						// 执行登录操作
						var password = md5(_this.lgfm.psw);
						// var password = localStorage.ch_isRemember == 1 ? this.loginForm.checkPass : md5(this.loginForm.checkPass);  
						var encrypt = new JSEncrypt()
						encrypt.setPublicKey(_this.pbkey)
						var psw = encrypt.encrypt(password)

						_this.$login(_this.lgfm.id, psw, _this.lgfm.code, _this.coderes.codeId, (res) => {
							_this.loading = false
							if (res.status == 200) {

								_this.$clearTmp()

								_this.lgfm.id = ''
								_this.lgfm.psw = ''

								localStorage.token = res.data.token
								_this.$setTmp('user', res.data)

								_this.$setTmp('loginTag', 'ok')
								window.location.reload(true)

							} else if (res.status == 401) {
								_this.tmptoken = res.data
								_this.showdia = true
								_this.$message.error(res.message)
							} else {
								_this.$message.error(res.message)
							}
						}, () => {
							_this.loading = false;
							_this.$message.error('request error')
						})
					}
				})
			}
		}
	}
</script>

<style>
	#login {
		width: 100%;
		height: 100%;
		position: absolute;
		overflow: hidden;
		background: rgba(249, 252, 255, 1);
		text-align: center;
	}

	#lgbg {
		height: 100%;
		width: 100%;
		background-repeat: no-repeat;
		background-size: 100% auto;
		background-image: url('../assets/lgbg.png');
		position: absolute;
	}

	#lgform {
		left: calc(50% - 217.5px);
		top: calc(50% - 238px);
		z-index: 1000;
		position: absolute;
		width: 435px;
		height: 550px;
		box-shadow: 0px 0px 20px 0px rgba(29, 35, 41, 0.05);
		border-radius: 8px;
		background: white;
		text-align: center;
	}

	#lgform img {
		height: 5.161%;
		margin: 21.129% auto 0 auto;
		display: block;
	}

	#lgtt {
		margin-top: 5.161%;
		color: rgba(0, 0, 0, 0.85);
		font-size: 23px;
		font-weight: bold;
	}

	#lgformct {
		width: 63.448%;
		margin: 7.741% auto 0 auto;
		/* background: blue; */
	}

	#lgfun {
		margin: 3.87% auto 0 auto;
		width: 63.448%
	}

	#lgbtn {
		margin: 3.87% auto 0 auto;
		width: 63.448%;
	}

	#lgcpcp {
		z-index: 1;
		position: absolute;
		height: 20px;
		line-height: 20px;
		font-size: 12px;
		font-weight: 400;
		color: rgba(0, 0, 0, 0.45);
		bottom: 24px;
		width: 100%;
		text-align: center;
	}
</style>
